'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { captureUtmsFromSearch } from '@/lib/utm-cookie'

export function UtmCapture() {
  const pathname = usePathname()

  useEffect(() => {
    captureUtmsFromSearch(window.location.search)
  }, [pathname])

  return null
}
